export const classes = {
  headingClass: 'text-secondary',
  wrapper: 'relative mb-10',
  content: 'flex flex-col md:flex-row gap-10',
  tableIcons: {
    wrapper: 'flex flex-col justify-center space-y-1',
    item: 'flex gap-2 capitalize text-secondary font-[800]',
  },
  stripe: {
    wrapper: 'mb-5 w-full static md:absolute left-0 bottom-0 flex',
    blue: 'hidden md:block rounded-l-lg h-4 w-4/12 bg-[#4c77ee]',
    purple: 'rounded-r-lg md:h-4 md:w-8/12 md:bg-[#9c4caf]',
  },
  actions:
    'w-full flex flex-col md:flex-row md:items-center md:justify-end gap-2 bg-transparent h-auto',
};
